import React, { useState } from "react";

import { Button, Card, Checkbox, Col, Divider, Form, Grid, Input, message, Row, Segmented, Space, theme, Typography } from "antd";
import LockLogo from "../../assets/png/lock.png"
import '../../style/auth.css'
import { useNavigate } from "react-router-dom";
import LoginPage from "../../assets/png/login_side.png"
import { ArrowLeft } from "lucide-react";
import { managerCheckin } from "../../service/api";

function PinValidate() {
    const [otp, setOtp] = useState("");
    const [isLoading, setIsLoading] = useState(false)
    const [form] = Form.useForm()
    const navigate = useNavigate()

    // const loginApi = userType === "Admin" ? adminLogin : staffLogin

    const onFinish = async () => {
        setIsLoading(true);
        try {
            const res = await managerCheckin({ pin: otp });
            if (res.status === 201) {
                navigate("/");

            }
            
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false);
        }
    };

    const onFinishFeild = (value) => {
        message.error("PIN  is required !")
        console.log(value)
    }

    return (
        <section className="login_section">
            <Row>
                <Col sm={24} md={24} lg={16} className="image_section">
                    <img src={LoginPage} />
                </Col>
                <Col sm={24} md={24} lg={8} className="login_pin">
                    <Card>
                        <div className="pin_validate gradient-border">
                            <img src={LockLogo} />
                            {/* <h2>Sign In Kiosk</h2> */}
                        </div>
                        <Divider orientation="center"  ><span className="light_color">Enter 4 digit PIN</span></Divider>
                        <Form
                            form={form}
                            name="normal_login"
                            onFinish={onFinish}
                            onFinishFailed={onFinishFeild}
                            layout="vertical"
                        >

                            <Form.Item
                                name="pin"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter your pin "
                                    },
                                    {
                                        pattern: /^[0-9]+$/,
                                        message: "Only numbers are allowed!",
                                    },
                                ]}
                            >
                                <center>
                                    <Input.OTP length={4} onChange={(value) => {
                                        setOtp(value);
                                        form.setFieldsValue({ pin: value });
                                    }} />
                                </center>
                            </Form.Item>

                            <Form.Item >
                                <Button className="pin_btn" size="large" block="true" loading={isLoading} htmlType="submit">
                                    Continue...
                                </Button>
                                <small className="light_color" >Don’t know the PIN? Ask your admin.</small>
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
            </Row>
            <div className="back_btn">
                <Button icon={<ArrowLeft size={20} />} shape="circle" onClick={() => navigate(-1)}></Button>
            </div>
        </section>
    );
}

export default PinValidate